import styled from 'styled-components'

import mediaQueries from 'components/media-queries'
import e2eClasses from 'helpers/automation'

export const Container = styled.div.attrs(() => ({
  className: e2eClasses('home.promotion.box')
}))`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.alabaster};
  & > div {
    padding: 0 22px 22px;
    max-width: 1200px;
  }
`

export const ContentWrapper = styled.div`
  width: 100%;
`

export const StyledTab = styled.button.attrs(() => ({
  className: e2eClasses('home.promotion.tabItemTitle')
}))`
  border: none;
  font-size: 1.125rem;
  background: none;
  cursor: pointer;
  justify-content: center;
  padding-bottom: 12px;
  font-family: ${({ theme }) => theme.fonts.regular};
  padding: 10px;
  margin-right: 20px;
  text-align: center;

  ${({ selected, theme }) =>
    selected
      ? `border-bottom: 3px solid ${theme.colors.blue};
      color: ${theme.colors.blue};`
      : `color: ${theme.colors.doveGray};
    `};

  &:hover {
    border-bottom: 3px solid ${({ theme }) => theme.colors.blue};
  }

  ${mediaQueries.tablet`
    padding: 7px 30px;
  `};

  ${mediaQueries.mobile`
    padding: 10px 0;
    :last-child {
      margin-right: 0;
    }
  `}

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.black};
  }
`

export const PanelContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const Panel = styled.div.attrs(() => ({
  className: e2eClasses('home.promotion.panelBox')
}))`
  width: 100%;
  display: grid;
  grid-gap: 10px;
  min-height: 440px;
  grid-template-columns: repeat(4, 1fr);
  ${({ scrollable }) => scrollable && 'padding: 0 0 80px;'};

  ${mediaQueries.tablet`
    grid-template-columns: repeat(4, 30%);

    overflow-y: hidden;
    overflow-x: auto;
  `};

  ${mediaQueries.mobile`
      grid-template-columns: ${({ scrollable }) =>
        scrollable ? 'repeat(4, 80%)' : 'repeat(1, 1fr)'};
      ${({ scrollable }) => scrollable && 'padding: 15px 0 80px;'};
      ${({ fixHeightOnIosMobile }) =>
        fixHeightOnIosMobile && 'height: 80vh; height: -webkit-fill-available;'};
  `};
`
